import { render, staticRenderFns } from "./my-tag.vue?vue&type=template&id=38d68145&scoped=true&"
import script from "./my-tag.vue?vue&type=script&lang=js&"
export * from "./my-tag.vue?vue&type=script&lang=js&"
import style0 from "./my-tag.vue?vue&type=style&index=0&id=38d68145&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d68145",
  null
  
)

export default component.exports